export const wait = (time: number) =>
  new Promise<void>((reslove) =>
    setTimeout(() => {
      reslove();
    }, time)
  );
